/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { MODEL_VIEWER_HOST } from '../../constants/constants'
const ModelViewerAPIConsumer = (props) => {

   const { listData, setCurrentStepIndex, setModelLoaded } = props

   const handleOnMessage = (event) => {
      // console.log('event message', event)
      if (event.origin === MODEL_VIEWER_HOST
         || event.origin === 'https://kilt-configurator.web.app') {
         const { action, payload } = event.data
         switch (action) {
            case 'MATERIAL_SELECTED':
               handleMaterailSelected(payload)
               break;
            case 'MODEL_LOADED':
               handleModelLoaded(payload)
               break;
            default:
               break;
         }

      } else {
         // console.log('Origin not allowed: ', { origin: event.origin })
      }
   }


   useEffect(() => {
      window.addEventListener('message', (event) => handleOnMessage(event))
      return () => {
         window.removeEventListener('message', handleOnMessage)
      }
   }, [])

   function handleMaterailSelected (payload) {
      let { materialClickedName } = payload
      if (materialClickedName.indexOf('kilt-') !== -1) {
         materialClickedName = materialClickedName.substring(materialClickedName.indexOf('kilt') + 5)
      }
      //get the material id from the list
      for (let i = 0; i < listData.length; i++) {
         const element = listData[i];
         if (materialClickedName.startsWith(element.materialId)) {
            setCurrentStepIndex(i)
            break
         }
      }

   }

   function handleModelLoaded (payload) {
      const { modelLoaded } = payload
      //get the material id from the list
      setModelLoaded(modelLoaded)

   }

   return null
}
export default ModelViewerAPIConsumer